<div class="dashletActivity">
  <div class="dashletActivity__container">
    <pp-icon
      class="dashletActivity__icon"
      [ppSrc]="EIconPath.ICON_MISC_LINK_18"
      ppClass="setSize18"
      ppColor="grey-800"
    />

    <div class="dashletActivity__text">
      @if (ppAction !== 'REMOVED') {
        <span>
          {{ 'activity_added_relationship' | ppTranslate }}
          <strong class="timeline__strong">{{
            relatedPointTypeLabelKey[ppRelationshipType] | ppTranslate
          }}</strong>
          for
          <strong class="timeline__strong">{{ ppRelatedPointTitle }}</strong
          >.
        </span>
      }
      @if (ppAction === 'REMOVED') {
        <span>
          {{ 'activity_removed_relationship' | ppTranslate }}
          <strong class="timeline__strong">{{
            relatedPointTypeLabelKey[ppRelationshipType] | ppTranslate
          }}</strong>
          for
          <strong class="timeline__strong">{{ ppRelatedPointTitle }}</strong
          >.
        </span>
      }
    </div>
  </div>
</div>
